"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MAX_ARROWS = exports.DEFAULT_ARROWS = exports.ArrowStyles = void 0; // Describes the arrow style of polylines

var ArrowStyles = {
  NONE: 0,
  FORWARD: 1,
  BACKWARD: 2,
  BOTH: 3
};
exports.ArrowStyles = ArrowStyles;
var DEFAULT_ARROWS = 1;
exports.DEFAULT_ARROWS = DEFAULT_ARROWS;
var MAX_ARROWS = 3;
exports.MAX_ARROWS = MAX_ARROWS;